// import React, { useState, useRef, useEffect } from "react";

import ItemReorderThreshold from "../../../../components/@operations/itemThreshold/ItemReorderThreshold";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemReorderThresholdPage() {

    return (
        <ItemReorderThreshold
            routeType={routeTypes.admin}
        />
    )
}